// removed by extract-text-webpack-plugin
module.exports = {"Main":"Companies__Main__3n2ky","Container":"Companies__Container__Uo_-T","Companies":"Companies__Companies__3vJs1"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Companies/Companies.css
// module id = 394
// module chunks = 0